import React from 'react'
import termsHtml from './termsHtml'

function TermsClassCopilot() {
  return (
    <div dangerouslySetInnerHTML={{ __html: termsHtml }} />
  )
}

export default TermsClassCopilot